export const soundKeys: string[] = [
  "/arh",
  "/dejligt",
  "/dubdubdub",
  "/feelinglikefools",
  "/gettodachoppa",
  "/hastalavista",
  "/honningkager",
  "/howmuchisthefish",
  "/hugohallo",
  "/hyperhyper",
  "/idontgiveapenny",
  "/ihatealltherules",
  "/illbeback",
  "/insane",
  "/imthekingoftheworld",
  "/kekw",
  "/lifeislikeaboxofchocolates",
  "/maytheforcebewithyou",
  "/nightmare",
  "/openmind",
  "/overandout",
  "/respect",
  "/stuck",
  "/united",
  "/wegotthepower",
  "/wewonteverstop",
  "/yes",
  "/båd",
];
